import React, { useState } from "react";
import axios from "axios";
import { ArrowLeft, Settings, Mail, Shield, AlertTriangle, ChevronRight, Loader2, Key } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// MOBILSAFE Logo from official website
const MOBILSAFE_LOGO = "/logo-mobilsafe-claro.png";

const LoginPanel = ({ onLogin, onBack, onForgotPassword }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    
    try {
      const response = await axios.post(`${API}/auth/login`, { email, password });
      const { access_token, user } = response.data;
      
      // Guardar token y datos del usuario
      localStorage.setItem('mobilsafe_token', access_token);
      localStorage.setItem('mobilsafe_user', JSON.stringify(user));
      localStorage.setItem('mobilsafe_auth', 'true');
      window.dispatchEvent(new Event('auth-changed'));
      
      onLogin(user);
    } catch (err) {
      if (err.response?.status === 401) {
        setError(err.response?.data?.detail || 'Credenciales incorrectas');
      } else {
        setError('Error de conexión. Inténtalo de nuevo.');
      }
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-emerald-900 to-slate-900 text-white flex items-center justify-center p-6">
      <div className="w-full max-w-md">
        <button onClick={onBack} className="flex items-center gap-2 text-emerald-300 hover:text-emerald-200 mb-8 transition-all">
          <ArrowLeft className="w-5 h-5" /> Volver
        </button>
        
        <div className="bg-white/5 backdrop-blur-lg border border-emerald-500/20 rounded-3xl p-8">
          <div className="text-center mb-8">
            <img 
              src={MOBILSAFE_LOGO} 
              alt="MOBILSAFE" 
              className="h-12 mx-auto mb-4"
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'flex';
              }}
            />
            <div className="hidden w-16 h-16 bg-gradient-to-br from-emerald-400 to-green-500 rounded-2xl items-center justify-center mx-auto mb-4 shadow-lg shadow-emerald-500/30">
              <Settings className="w-8 h-8 text-white" />
            </div>
            <h1 className="text-2xl font-black">Panel de Configuración</h1>
            <p className="text-emerald-300 text-sm mt-2">Acceso solo para comerciales</p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-bold mb-2 flex items-center gap-2">
                <Mail className="w-4 h-4 text-emerald-400" /> Email
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="tu@email.com"
                className="w-full px-4 py-3 bg-white text-slate-900 border-2 border-emerald-500/30 rounded-xl focus:ring-2 focus:ring-emerald-500 focus:border-emerald-400 transition-all placeholder-slate-400"
                data-testid="login-email"
                required
              />
            </div>
            
            <div>
              <label className="block text-sm font-bold mb-2 flex items-center gap-2">
                <Shield className="w-4 h-4 text-emerald-400" /> Contraseña
              </label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                className="w-full px-4 py-3 bg-white text-slate-900 border-2 border-emerald-500/30 rounded-xl focus:ring-2 focus:ring-emerald-500 focus:border-emerald-400 transition-all placeholder-slate-400"
                data-testid="login-password"
                required
              />
            </div>

            {error && (
              <div className="bg-red-500/20 border border-red-500/30 text-red-300 px-4 py-3 rounded-xl text-sm flex items-center gap-2">
                <AlertTriangle className="w-4 h-4" /> {error}
              </div>
            )}

            <button
              type="submit"
              disabled={loading}
              className="w-full py-4 bg-gradient-to-r from-emerald-500 to-green-500 hover:from-emerald-600 hover:to-green-600 rounded-xl font-bold text-lg shadow-lg shadow-emerald-500/30 transition-all flex items-center justify-center gap-2 disabled:opacity-50"
              data-testid="login-submit"
            >
              {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : <ChevronRight className="w-5 h-5" />}
              Acceder
            </button>

            {onForgotPassword && (
              <button
                type="button"
                onClick={onForgotPassword}
                className="w-full py-3 text-emerald-300 hover:text-emerald-200 transition-all flex items-center justify-center gap-2 text-sm"
                data-testid="forgot-password-btn"
              >
                <Key className="w-4 h-4" />
                ¿Has olvidado tu contraseña?
              </button>
            )}
          </form>
        </div>
      </div>
    </div>
  );
};

export default LoginPanel;
